import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import button from 'react-rte/lib/ui/Button';
import { noteStyles } from './styles';
import { CloseButton, Loader, MinLoader } from 'components';
import { FindLoad, Images, useModal, useSecondaryModal } from 'utils';
import { customerActions, loadActions } from 'store';
import { ReceivableNoteCard } from './receivableNoteCard';
import { AddReceivableNotes } from './addReceivableNotes';

const GET_ACTION_TYPE = 'GET_RECEIVABLES_NOTE';

export const ReceivableNoteDrawerModal = ({}) => {
  const { receivableNotes } = useSelector((state) => ({
    receivableNotes: state.loads.receivableNotes,
  }));
  const classes = noteStyles();
  const dispatch = useDispatch();
  const loadList = FindLoad(GET_ACTION_TYPE);
  const { open } = useModal({ noPadding: true, noCloseButton: true });
  const { closeSecondary } = useSecondaryModal();
  const [searchValue, setSearchValue] = useState('');
  const searchLoad = FindLoad('GET_RECEIVABLES_NOTE_SEARCH');

  useEffect(() => {
    getNotes();
  }, [dispatch]);

  const getNotes = (loading) => {
    dispatch(loadActions.getRecNotes({}, loading));
  };

  const handleSearch = () => {
    const params = {};
    searchValue ? params.searchKey = searchValue : delete params.searchKey;
    dispatch(loadActions.getRecNotes(params, 'noLoad', true));
  };

  useEffect(() => {
    dispatch(customerActions.getCustomers({ status: 'ACTIVE' }));
  }, []);


  const handleAddNote = () => {
    open(<AddReceivableNotes />);
  };

  const renderNoteBtn = () => {
    return (
      <button className={classes.addBtn} onClick={handleAddNote}>
        <div>
          <img src={Images.addWhiteIcon} alt={'icon'} />
        </div>
        <p>{'Add Note'}</p>
      </button>
    );
  };

  return (
    <div className='note-modal-wrapper'>
      {loadList?.length ?
        <Loader height={'100%'} />
        :
        <>
          <div className='receivables-note-header'>
            <p className={classes.noteModalTitle}>
              Receivables Notes
            </p>

            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div className='search-note-box'>
                <input
                  onChange={(e) => setSearchValue(e.target.value)}
                  placeholder={'by customer name, load ID, reference...'}
                  type='text'
                  value={searchValue}
                />
                <button onClick={handleSearch}>
                  {searchLoad?.length ?
                    <MinLoader margin={'0'} color={'#51566D'} position={'relative'} />
                    :
                    <img src={Images.searchIcon} alt='icon' />
                  }
                </button>
              </div>

              {renderNoteBtn()}

              <CloseButton handleCLic={closeSecondary} />
            </div>
          </div>

          <div className={classes.noteModalBox}>
            {receivableNotes?.length ?
              <div className={classes.userNotes} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                {receivableNotes?.map((item, index) => (
                  <ReceivableNoteCard key={index} item={item} searchValue={searchValue}/>
                ))}
              </div>
              :
              <div className='receivable-notes-no-data-wrapper'>
                <div className='receivable-notes-no-data-box'>
                  <div className='receivable-notes-no-data-img'>
                    <img src={Images.receivableNotesEmpty} alt='receivable Notes Empty' />
                  </div>

                  <p className='receivable-notes-no-data-title'>No notes available!</p>
                  <p className='receivable-notes-no-data-text'>You haven’t added any notes yet. Click “Add Note” to get
                    started.</p>
                </div>
              </div>
            }
          </div>
        </>
      }
    </div>
  );
};